module.exports = __webpack_public_path__ + "media/images/account/icon8-6e2202e294e3724c3f19fde117cbbba3.svg";